import React, { useMemo, useState } from 'react'
import { GlobalTab } from '../../../../Components/global/globalTab/GlobalTab'
import styles from './threePsCodeHeader.module.css'
import { Button } from '@mui/material';
import { EditIcon } from '../../../../Components/Icons/editIcon';
import { UserContext, UserPayload } from '../../../../Context/userContext';
import { useThreePsCodesStore } from '../../store/threePsCodes.store';
import { selectIsEditMode, selectSelectedVendor, selectVendors } from '../../store/threePsSelectors';

interface IThreePsCodeHeaderProps {
    onSave: () => Promise<boolean>;
    onCancel: () => void;
    confirmChange?: () => boolean;
}

export const ThreePsCodeHeader = (props: IThreePsCodeHeaderProps) => {
    const { onSave, onCancel, confirmChange } = props;
    const { setShowLoader } = React.useContext(UserContext) as UserPayload;
    const vendors = useThreePsCodesStore(selectVendors);
    const selectedVendor = useThreePsCodesStore(selectSelectedVendor);
    const setSelectedVendor = useThreePsCodesStore((s) => s.setSelectedVendor);
    const isEditMode = useThreePsCodesStore(selectIsEditMode);
    const setIsEditMode = useThreePsCodesStore((s) => s.setIsEditMode);
    const [currentTab, setCurrentTab] = useState(selectedVendor ? vendors.indexOf(selectedVendor) : 0);

    const tabList = useMemo(
        () =>
            vendors.map((vendor, index) => ({
                name: vendor,
                id: index,
            })),
        [vendors]
    );

    const handleChangeTab = (_: React.SyntheticEvent, newValue: number) => {
        const allowed = confirmChange ? confirmChange() : true;
        if (!allowed) return;

        setCurrentTab(newValue);
        setSelectedVendor(tabList[newValue].name, { setShowLoader });
    };

    const handleEdit = async () => {
        if (isEditMode) {
            const isSaveSuccessful = await onSave?.();
            if (isSaveSuccessful) {
                setIsEditMode(false);
            }
        } else {
            setIsEditMode(true);
        }
    };

    const handleCancel = () => {
        onCancel?.();
        setIsEditMode(false);
    };

    return (
        <div className={styles.threePsCodesHeader}>
            {vendors.length > 0 && (
                <GlobalTab
                    tabList={tabList}
                    currentTab={currentTab}
                    ChangeTab={handleChangeTab}
                />
            )}
            <div className={styles.editButtonContainer}>
                {isEditMode && <Button className={styles.cancelButton} onClick={handleCancel} disabled={!selectedVendor}>
                    Cancel
                </Button>}
                <Button className={styles.editButton} startIcon={isEditMode ? undefined : <EditIcon width={14} height={14} />} onClick={handleEdit} disabled={!selectedVendor}>
                    {isEditMode ? 'Save' : 'Edit'}
                </Button>
            </div>
        </div>
    )
}
